export default {
	materialUnavailable: {
		singleLine1: "Das Material dieses Artikels ist nicht verfügbar.",
		singleLine2: "Klicken Sie hier, um das Material anzupassen.",
		assemblyLine1:
			"Das Material eines oder mehrerer Einzelartikels dieser Baugruppe ist nicht verfügbar.",
		assemblyLine2: "Klicken Sie hier, um die Einzelartikel anzuzeigen.",
	},
	cad: {
		tooltipLine1: "Öffnet das CAD Modell im Browser.",
		tooltipLine2:
			"Im integrierten CAD Editor von Blexon können Sie Gewinde, Senkungen, Gravuren, Schweißnähte usw. einfügen / bearbeiten.",
		tooltipLine3: "Ausserdem Maße kontrollieren, Meldungen anzeigen und Fehlerursachen beheben.",
	},
	features: {
		label: "Bearbeitungen",
		basePrimed: "- vorgrundiert",
		engraving: "Gravur",
	},
	info: {
		articleNumberLabel: "Artikel Nr:",
		blexonNumberLabel: "Blexon Nr:",
		materialTypeLabel: "Werkstoff:",
		thicknessLabel: "Dicke:",
		topSideLabel: "Oberseite",
		bottomSideLabel: "Unterseite",
		quantityInAssemblyLabel: "Anzahl in Baugruppe:",
		dimensionsLabel: "LxBxH:",
		weightLabel: "Gewicht:",
		deburringLabel: "Entgraten:",
		powderCoatingLabel: "Pulverbeschichtung:",
		zincCoatingLabel: "Verzinken:",
		certificateLabel: "Zertifikat:",
		certificateInfoTooltip: "Weitere Informationen über Zertifikat",
		noCoating: "Keine",
		materialDivers: "Material: Divers",
		additionalDesignationGrinded: " / Schliff / Folie",
		additionalDesignationAnodized: " / Folie",
		additionalDesignationRibbed: " / Riffeln",
	},
	assembly: {
		moreText: "mehr...",
		showSubarticlesButton: "Einzelartikel anzeigen",
		showSubarticlesTooltip: "Zeigt alle Artikel dieser Baugruppe an.",
		calculatingMessage: "Einige Artikel in dieser Baugruppe werden zurzeit kalkuliert.",
		noValidBodies:
			"Baugruppe enthält keine gültigen Volumenkörper. Evtl. sind die Körper offen oder nur als Oberfläche definiert.",
		checkSubarticlesHint:
			"Klicken Sie auf 'Einzelartikel anzeigen', um die Status der einzelnen Artikel zu sehen und erforderliche Aktionen auf ihnen auszuführen.",
	},
	state: {
		errorHint:
			"Öffnen Sie den Artikel im CAD und überprüfen Sie den Fehler, oder senden Sie ihn zur kostenlosen Abklärung an unser Helpdesk.",
		infoHint:
			"Bitte öffnen Sie den Artikel im CAD und definieren Sie, was mit den erkannten Bearbeitungen gemacht werden soll.",
		inReview: "In Überprüfung",
		ok: "OK",
		warning: "Warnung",
		error: "Fehler",
		new: "Neu",
		actionRequired: "Aktion erforderlich",
		unclear: "Unklar",
	},
	cart: {
		quantityPlaceholder: "Menge",
		addToCartButton: "In Warenkorb",
		addToCartTooltip: "Fügt den Artikel zum Warenkorb hinzu.",
		addedToCartSnackbar: "{quantity} Stück in den Warenkorb gelegt.",
		assemblyPartCannotOrder:
			"Artikel, die Teil einer Baugruppe sind, können nicht einzeln bestellt werden.",
		powderCoatingEngravingConflictLine1:
			"Artikel mit Pulverbeschichtung und Gravur können nicht bestellt werden.",
		powderCoatingEngravingConflictLine2:
			"Die Gravur würde von der Pulverbeschichtung vollständig überdeckt.",
		powderCoatingEngravingConflictLine3:
			"Entfernen Sie entweder die Gravur oder die Pulverbeschichtung, um den Artikel bestellen zu können.",
		cannotBeProducedInRegion: "Artikel kann aktuell in {region} nicht bestellt werden.",
	},
	buttons: {
		openCad: "CAD Modell anzeigen / bearbeiten",
		sendToHelpdesk: "An Helpdesk senden",
		sendToHelpdeskTooltipLine1: "Artikel wird an unser Helpdesk gesendet und kostenlos analysiert.",
		sendToHelpdeskTooltipLine2: "Sie werden informiert, sobald wir Ihren Artikel bearbeitet haben.",
		blexonize: "Artikel blexonisieren",
		blexonizeTooltipLine1: "Der Artikel wurde noch nicht mit der neuesten Version blexonisiert.",
		blexonizeTooltipLine2:
			"Um den Artikel zu bestellen, im CAD zu überprüfen oder zu ändern, klicken Sie bitte hier.",
	},
	messages: {
		checkCartMembershipError:
			"Aktuell kann nicht überprüft werden, ob der Artikel in einer Stückliste verwendet wird.",
	},
	header: {
		selectForMultiActionTooltip:
			"Auswählen für Mehrfachaktion. Mögliche Aktionen werden oben angezeigt.",
		contextMenuTooltip: "Öffnet das Kontextmenü zum Artikel.",
		edit: "Bearbeiten",
		delete: "Löschen",
		unlock: "Unlock",
		lock: "Lock",
	},
	pricelist: {
		openTooltip: "Öffnet die Preisliste des Artikels.",
		button: "Preisliste",
		pricesNotCalculatedLine1: "Für diesen Artikel konnten die Preise nicht berechnet werden.",
		pricesNotCalculatedLine2:
			"Bitte senden Sie den Artikel für eine kostenlose Abklärungen an unser Helpdesk.",
		priceInfoTooltip: "Erfahren Sie hier, wie Sie Ihre Artikel noch günstiger bekommen.",
		priceHintLabel: "Preishinweis",
		pricePerUnitMulti: "Preis / Stk. [{currency}]",
		pricePerUnitSingle: "Preis/Stk. [{currency}]",
		quantityLabel: "Menge",
		fromQuantity: "ab {quantity}",
		addQuantityToCartTooltip: "{quantity} Stück in den Warenkorb",
		hintTitle: "Den finalen Preis inkl. Mengenrabatt sehen Sie im Warenkorb.",
		hintText:
			"Mehrere Artikel mit gleichen Bearbeitungen oder gleichem Material führen zu einem Preisnachlass. Um den definitiven Preis zu kalkulieren, stellen Sie bitte einen Warenkorb zusammen und lassen Sie sich innert Sekunden ein Angebot inkl. Liefertermin berechnen.",
		loadError: "Preise für Artikel konnten nicht geladen werden.",
	},
};
